/* BlueTruck24 hub theme — product page. Vanilla, no dependencies, loaded with
   `defer` by sections/bt-main-product.liquid (after assets/theme.js).
   Client-side parts of ($locale).products.$handle.tsx: ProductGallery (thumbnails +
   lightbox), DescriptionTabs (tabs + FAQ accordion) and variant switching
   (Hydrogen: useOptimisticVariant + ?Option=Value; here ?variant=<id>).
   The class strings below mirror the Liquid section — change them together. */
(function () {
  'use strict';

  var root = document.querySelector('[data-bt-product]');
  if (!root) return;

  var THUMB_ON = 'border-brand';
  var THUMB_OFF = 'border-line hover:border-ink-muted';
  var TAB_ON = 'border-brand text-brand-700';
  var TAB_OFF = 'border-transparent text-ink-muted hover:text-ink';
  var FAQ_ARROW_ON = 'rotate-180';
  var FAQ_PANEL_ON = 'max-h-[600px] pb-5';
  var FAQ_PANEL_OFF = 'max-h-0';
  var OPTION_ON = 'border-brand';
  var OPTION_OFF = 'border-line hover:border-ink-muted';
  var OPTION_UNAVAILABLE = 'opacity-30';

  function $(selector, scope) {
    return (scope || root).querySelector(selector);
  }
  function $all(selector, scope) {
    return Array.prototype.slice.call((scope || root).querySelectorAll(selector));
  }
  function setClasses(el, on, whenOn, whenOff) {
    if (!el) return;
    (on ? whenOff : whenOn).split(' ').forEach(function (name) { if (name) el.classList.remove(name); });
    (on ? whenOn : whenOff).split(' ').forEach(function (name) { if (name) el.classList.add(name); });
  }

  // ── Gallery + lightbox ───────────────────────────────────────────────────
  var slides = $all('[data-bt-gallery-image]');
  var thumbs = $all('[data-bt-gallery-thumb]');
  var lightbox = $('[data-bt-lightbox]');
  var zoomImage = lightbox && $('[data-bt-zoom-image]', lightbox);
  var zoomCounter = lightbox && $('[data-bt-zoom-counter]', lightbox);
  var zoomFocus = lightbox && $('[data-bt-zoom-focus]', lightbox);
  var active = 0;
  var previousFocus = null;

  function paintLightbox() {
    var slide = slides[active];
    if (!slide || !zoomImage) return;
    zoomImage.src = slide.getAttribute('data-bt-zoom-src') || slide.currentSrc || slide.src;
    zoomImage.alt = slide.getAttribute('alt') || root.getAttribute('data-title') || '';
    // Keep the intrinsic ratio of the slide so the browser reserves the right box.
    if (slide.getAttribute('width')) zoomImage.setAttribute('width', slide.getAttribute('width'));
    if (slide.getAttribute('height')) zoomImage.setAttribute('height', slide.getAttribute('height'));
    if (zoomCounter) zoomCounter.textContent = (active + 1) + ' / ' + slides.length;
  }

  function setActive(index) {
    if (!slides.length) return;
    active = (index + slides.length) % slides.length;
    slides.forEach(function (slide, i) { slide.hidden = i !== active; });
    thumbs.forEach(function (thumb, i) { setClasses(thumb, i === active, THUMB_ON, THUMB_OFF); });
    if (lightbox && !lightbox.hidden) paintLightbox();
  }

  // Lightbox keys: Escape closes, arrows switch images, Tab stays inside the dialog.
  function onLightboxKey(event) {
    if (event.key === 'Escape') return closeLightbox();
    if (event.key === 'ArrowRight') return setActive(active + 1);
    if (event.key === 'ArrowLeft') return setActive(active - 1);
    if (event.key !== 'Tab') return;
    // The backdrop button is tabindex="-1": keep it out of the Tab cycle.
    var focusable = $all('button:not([disabled]), [href], [tabindex]', lightbox).filter(function (el) {
      return el.getAttribute('tabindex') !== '-1';
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openLightbox() {
    if (!lightbox || !slides.length) return;
    previousFocus = document.activeElement;
    lightbox.hidden = false;
    paintLightbox();
    window.addEventListener('keydown', onLightboxKey);
    document.body.style.overflow = 'hidden';
    if (zoomFocus) zoomFocus.focus();
  }

  function closeLightbox() {
    if (!lightbox || lightbox.hidden) return;
    lightbox.hidden = true;
    window.removeEventListener('keydown', onLightboxKey);
    document.body.style.overflow = '';
    if (previousFocus && previousFocus.focus) previousFocus.focus();
  }

  // ── Description | FAQ tabs + FAQ accordion (one item open at a time) ─────
  var tabButtons = $all('[data-bt-tab]');
  var tabPanels = $all('[data-bt-tab-panel]');
  var faqItems = $all('[data-bt-faq-item]');

  function setTab(name) {
    tabButtons.forEach(function (button) {
      setClasses(button, button.getAttribute('data-bt-tab') === name, TAB_ON, TAB_OFF);
    });
    tabPanels.forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-bt-tab-panel') !== name;
    });
  }

  function setFaq(openIndex) {
    faqItems.forEach(function (item, i) {
      var open = i === openIndex;
      var button = $('[data-bt-faq-button]', item);
      if (button) button.setAttribute('aria-expanded', String(open));
      setClasses($('[data-bt-faq-arrow]', item), open, FAQ_ARROW_ON, '');
      setClasses($('[data-bt-faq-panel]', item), open, FAQ_PANEL_ON, FAQ_PANEL_OFF);
    });
  }

  // ── Variants ─────────────────────────────────────────────────────────────
  var data = null;
  var dataEl = $('[data-bt-product-json]');
  if (dataEl) {
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      data = null;
    }
  }
  var variants = (data && data.variants) || [];
  var strings = (data && data.strings) || {};
  var form = $('form[data-bt-product-form]');
  var optionButtons = $all('[data-bt-option-value]');
  var selected = [];

  function findVariant(options) {
    for (var i = 0; i < variants.length; i++) {
      var candidate = variants[i];
      var match = candidate.options.length === options.length && candidate.options.every(function (value, k) {
        return value === options[k];
      });
      if (match) return candidate;
    }
    return null;
  }

  function setAvailable(button, available) {
    if (!button) return;
    button.disabled = !available;
    // theme.js keeps a button disabled after a request while this attribute is present.
    if (available) button.removeAttribute('data-bt-unavailable');
    else button.setAttribute('data-bt-unavailable', '');
  }

  // Same three states as ProductForm.tsx: selected, exists (else disabled), available (else faded).
  function paintOptions() {
    optionButtons.forEach(function (button) {
      var index = Number(button.getAttribute('data-option-index'));
      var value = button.getAttribute('data-value');
      var candidate = selected.slice();
      candidate[index] = value;
      var variant = findVariant(candidate);
      var isSelected = selected[index] === value;
      setClasses(button, isSelected, OPTION_ON, OPTION_OFF);
      button.setAttribute('aria-pressed', String(isSelected));
      button.disabled = !variant;
      button.classList.toggle(OPTION_UNAVAILABLE, !(variant && variant.available));
    });
  }

  function paintVariant(variant) {
    if (form && form.elements.id) form.elements.id.value = String(variant.id);

    var price = $('[data-bt-price]');
    var net = $('[data-bt-net-price]');
    var compare = $('[data-bt-compare-price]');
    var badge = $('[data-bt-sale-badge]');
    var sku = $('[data-bt-sku]');
    // Money strings were formatted by Liquid (`| money`), so they go in as markup.
    if (price) price.innerHTML = variant.price;
    if (net) net.innerHTML = variant.net;
    if (compare) {
      compare.innerHTML = variant.compare || '';
      compare.hidden = !variant.compare;
    }
    if (badge) badge.hidden = !variant.compare;
    if (sku) {
      sku.textContent = 'SKU: ' + (variant.sku || '');
      sku.hidden = !variant.sku;
    }

    var addButton = document.querySelector('[data-bt-action="add"]');
    if (addButton) addButton.textContent = variant.available ? strings.addToCart : strings.unavailable;
    setAvailable(addButton, variant.available);
    setAvailable(document.querySelector('[data-bt-action="buy-now"]'), variant.available);
    // Mobile bottom nav: "Buy now" / "Add to cart" tabs follow the selected variant.
    $all('[data-bt-buy-now],[data-bt-add-to-cart-quiet]', document).forEach(function (button) {
      setAvailable(button, variant.available);
    });

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (e) { /* URL API unavailable */ }
  }

  if (variants.length > 1) {
    var current = null;
    variants.forEach(function (variant) {
      if (variant.id === data.current) current = variant;
    });
    current = current || variants[0];
    selected = current.options.slice();
    // A restored page (back/forward) may carry a stale hidden id.
    if (form && form.elements.id) form.elements.id.value = String(current.id);
    paintOptions();
  }

  // ── Events (the wishlist hearts are handled by theme.js through data-bt-wishlist) ──
  root.addEventListener('click', function (event) {
    var target = event.target.closest('[data-bt-zoom-open],[data-bt-zoom-close],[data-bt-zoom-prev],[data-bt-zoom-next],[data-bt-gallery-thumb],[data-bt-tab],[data-bt-faq-button],[data-bt-option-value]');
    if (!target || !root.contains(target)) return;

    if (target.hasAttribute('data-bt-zoom-open')) {
      openLightbox();
    } else if (target.hasAttribute('data-bt-zoom-close')) {
      closeLightbox();
    } else if (target.hasAttribute('data-bt-zoom-prev')) {
      setActive(active - 1);
    } else if (target.hasAttribute('data-bt-zoom-next')) {
      setActive(active + 1);
    } else if (target.hasAttribute('data-bt-gallery-thumb')) {
      setActive(thumbs.indexOf(target));
    } else if (target.hasAttribute('data-bt-tab')) {
      setTab(target.getAttribute('data-bt-tab'));
    } else if (target.hasAttribute('data-bt-faq-button')) {
      var item = target.closest('[data-bt-faq-item]');
      var isOpen = target.getAttribute('aria-expanded') === 'true';
      setFaq(isOpen ? -1 : faqItems.indexOf(item));
    } else if (target.hasAttribute('data-bt-option-value')) {
      var index = Number(target.getAttribute('data-option-index'));
      var value = target.getAttribute('data-value');
      if (selected[index] === value) return;
      var next = selected.slice();
      next[index] = value;
      var variant = findVariant(next);
      if (!variant) return;
      selected = next;
      paintOptions();
      paintVariant(variant);
    }
  });
})();
